import { AfterViewInit, Component, inject } from '@angular/core';
import { PaSelectButtonComponent } from '../../../../shared/ui-kit/pa-select-button/pa-select-button.component';
import { FormBuilder, FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { DictionaryDTO } from 'src/app/core/models/dictionary';

@Component({
  selector: 'app-select-button-view',
  templateUrl: './select-button-view.component.html',
  styleUrls: ['./select-button-view.component.scss'],
  imports: [PaSelectButtonComponent, FormsModule, ReactiveFormsModule],
  standalone: true,
})
export class SelectButtonViewComponent implements AfterViewInit {
  private fb = inject(FormBuilder);

  cities: DictionaryDTO[] = [
    { name: 'Нью-Йорк', id: 'NY' },
    { name: 'Рим', id: 'RM' },
    { name: 'Лондон', id: 'LDN' },
    { name: 'Стамбул', id: 'IST' },
    { name: 'Париж', id: 'PRS' },
  ];

  statuses: DictionaryDTO[] = [
    { name: 'Активный', id: 'active' },
    { name: 'Неактивный', id: 'inactive' },
    { name: 'Заблокирован', id: 'blocked' },
  ];

  priorities: DictionaryDTO[] = [
    { name: 'Низкий', id: 'low' },
    { name: 'Средний', id: 'medium' },
    { name: 'Высокий', id: 'high' },
    { name: 'Критический', id: 'critical' },
  ];

  form = this.fb.group({
    city: new FormControl(),
    status: new FormControl(),
    priority: new FormControl(),
  });

  form2 = this.fb.group({
    city: new FormControl({ value: 'LDN', disabled: true }),
  });

  form3 = this.fb.group({
    status: new FormControl('', Validators.required),
  });

  form4 = this.fb.group({
    priority: new FormControl(['medium', 'high']),
  });

  form5 = this.fb.group({
    priority: new FormControl([], Validators.required),
  });

  selectButtonErrorMessages = {
    required: 'Необходимо выбрать хотя бы один статус.',
  };

  ngAfterViewInit(): void {
    const control = this.form5.get('priority');
    if (control) {
      control.markAsTouched();
      control.updateValueAndValidity();
    }
  }


  constructor() {}
}
